angular.module('bmsApp.settings').controller('GroupSaveCtrl', 
	function ($scope, $modalInstance) {
		
//		console.log(group);
		
		
		console.info($scope.group);
		$scope.submit = function(){
			
			
			
			
			
			
		};
		
		
		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};
	}
);
